<template>
  <div class="dcf-grid dcf-row-gap-5 dcf-col-gap-5">
    <div class="dcf-col-100% dcf-col-25%-start@md">
      <div class="unl-font-sans unl-bg-lightest-gray dcf-p-2 bov-list">
        <ul class="dcf-list-bare dcf-txt-sm">
          <li v-for="video in videos" :class="activeVideo && (activeVideo.id == video.id) ? 'dcf-pl-1 active' : 'dcf-pl-1 '">
            <a class="dcf-txt-decor-none" href="#" v-on:click.prevent="activeVideo = video">{{ video.title }}</a>
          </li>
        </ul>
      </div>      
    </div>
    <div class="dcf-col-100% dcf-col-75%-end@md">
      <div v-if="activeVideo != null">
        <h2>{{ activeVideo.title }}</h2>
        <div class="dcf-ratio dcf-ratio-16x9">
          <iframe class="dcf-ratio-child dcf-w-100% dcf-h-100%" :src="'https://www.youtube.com/embed/' + activeVideo.youtube_id" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      videos: [],
      activeVideo: null
    }
  },
  computed: {

  },
  methods: {

  },
  created: function(){
    this.videos = window.videos;
  }
}
</script>
